import { createUseStyles } from 'react-jss';
import { Spacings, Radius, Backgrounds } from '@picsart/cascade';

import { zShareModalOverlay } from 'utils/ui-helpers/stackingContexts';

const useStyles = createUseStyles({
  modalOverlay: {
    width: '100vw',
    height: '100vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'fixed',
    top: Spacings.s0,
    left: Spacings.s0,
    right: Spacings.s0,
    bottom: Spacings.s0,
    zIndex: zShareModalOverlay,
    backgroundColor: Backgrounds.transparent,
  },
  modalStyles: {
    position: 'absolute',
    borderRadius: Radius.r16,
    pointerEvents: 'auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Backgrounds.positive,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: `calc(100vw - ${Spacings.s24})`,
    maxHeight: `calc(100vh - ${Spacings.s24})`,
  },
  close: {
    width: 32,
    height: 32,
    '& svg': {
      width: 14,
      height: 14,
    },
  },
  content: {
    display: 'block',
    '--image-box-width': props => `${props?.imageBoxSize}px`,
    '--image-width': props => props?.imageWidth,
    '--image-height': props => props?.imageHeight,
    '--zoom': props => props?.zoom,
    '--image-scale': props => props?.imageScale,
    '--image-box-scroll-left': props => props?.imageBoxScrollLeft,
  },
  imageBoxWrapper: {
    width: 'var(--image-box-width)',
    maxWidth: '100%',
    aspectRatio: '1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    // Used instead of overflow hidden for rounded appearance
    '-webkit-mask-image': '-webkit-radial-gradient(circle, black 100%, white 100%)',
  },
  imageBox: {
    display: 'block',
    width: 'calc(var(--image-width) * var(--zoom))',
    height: 'calc(var(--image-height) * var(--zoom))',
    maxWidth: '100%',
    maxHeight: '100%',
    position: 'relative',
  },
  imageZoomScrollBox: {
    maxWidth: '100%',
    maxHeight: '100%',
    overflow: 'auto',
    position: 'relative',
    display: 'block',
    width: 'calc(100% * var(--zoom))',
    height: 'calc(100% * var(--zoom))',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  imageZoomContainer: {
    willChange: 'clip-path',
    position: 'relative',
    transformOrigin: 'left top',
    transform: 'scale(var(--image-scale))',
    minWidth: 'var(--image-width)',
    minHeight: 'var(--image-height)',
  },
  image: {
    background: 'var(--transparent-background-image)',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    opacity: 0,
  },
  loadedImage: {
    opacity: 1,
  },
});

export default useStyles;
